import { environment as base } from '@haleo-frontend/utils';

export const environment = {
    ...base,
    appId: 'ca.haleo',
    amplitudeKey: '5af05ca636979bad1d391de47cd11200',
    firebaseConfig: {
        apiKey: "AIzaSyCLYyYiVaH0ECVCga8uCE4iZxNgQJWGEqs",
        authDomain: "haleo-6b3a9.firebaseapp.com",
        databaseURL: "https://haleo-6b3a9.firebaseio.com",
        projectId: "haleo-6b3a9",
        storageBucket: "haleo-6b3a9.appspot.com",
        messagingSenderId: "622370047242",
        appId: "1:622370047242:web:4e6bf3651264ed503326f3",
        measurementId: "G-HMJ6Q1BQ2G"
    },
    sentryDSN: 'https://0c5f0cb86920459cabec4f47ef4e0c2c@sentry-relay.haleo.ca/5593117',
    zoomWebSDKURL: 'https://haleo-6b3a9.firebaseapp.com/assets/html/zoom-external.html',
    appDynamicLink: 'https://haleoclinic.page.link/back-to-app',
    growthBookKey: 'sdk-xVSG7v4K7aHUxelz'
};
